<template>
  <div class="crowdfund-conf">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit"></ConfigTable>
    <EditIsWin ref="editDialog" @sure="callEdit"></EditIsWin>
  </div>
</template>

<script>
import ElementUI from 'element-ui';
import api from '../../../api/activeManagement';
import { boolTypes } from '../../../config';
import { changeDate, prefixZero } from '../../../utils/filter';
import EditIsWin from './components/EditIsWin.vue';
import ConfigTable from '@/components/config-table';

const searchConfig = [
  { type: 'input', placeholder: '输入众筹Id', key: 'crowdfundId' },
  { type: 'input', placeholder: '输入用户Id', key: 'uid' },
  { type: 'select', placeholder: '是否中奖', key: 'isWin', options: boolTypes },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
]
const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '众筹配置ID', width: 220, key: 'crowdfundId' },
  { name: '用户名', key: 'name' },
  { name: '用户ID', key: 'uid' },
  { name: '投注号码', key: 'num', valueHandler: prefixZero },
  {
    name: '是否中奖', key: 'isWin', component: ElementUI.Tag, props(val) {
      return { type: val ? 'success' : 'danger' }
    }, valueHandler(val) {
      return val ? '是' : '否'
    }
  },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit'] },
];

export default {
  name: 'CrowdfundRecord',
  components: { EditIsWin, ConfigTable },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await api.getCrowdfundRecordList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索众筹参与记录失败：', error);
      }
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async callEdit(r) {
      try {
        const res = await api.updateCrowdfundRecord(r.data)
        this.$message.success('更新成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {

      }
    },
  }
};
</script>

<style lang="scss" scoped>
.crowdfund-conf {
  .action-bar {
    .gap-left {
      margin-left: 10px;
    }

    .el-button {
      padding: 8px 15px;
    }

    .el-input {
      width: auto;
    }
  }

  .table-column-actions {
    display: flex;
    justify-content: center;
  }
}
</style>